import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
    createTicket,
    getCountries,
    getSupportTypes,
    getClaimCategories,
    setError,
} from '../Actions/Contact.action'
import ContactForm from '../Components/Contact'
import { object, string } from 'yup'
import { translate } from '../Services/translation'

const contactSchema = object().shape({
    message: string().required(translate(`validation.required`)),
    supportType: string().required(translate(`validation.required`)),
    country: string().required(translate(`validation.required`)),
    email: string()
        .required(translate(`validation.required`))
        .email(translate(`validation.email`)),
    name: string().required(translate(`validation.required`)),
})

const deliverySchema = object().shape({
    orderNumber1: string().required(translate(`validation.required`)),
})

const batchSchema = object().shape({
    batchNumber: string().required(translate(`validation.required`)),
})

class ContactContainer extends Component {
    constructor(props) {
        super(props)
        this.state = {
            contact: {
                supportType: 0,
            },
            file: null,
        }
    }

    componentDidMount() {
        this.props.loadCountries()
        this.props.loadSupportTypes()
        this.props.loadClaimCategories()
    }

    handleContactInputChange(propName, value) {
        this.setState((prevState) => ({
            ...prevState,
            contact: {
                ...prevState.contact,
                [propName]: value,
            },
        }))
    }

    onFileChange(file) {
        this.setState({ file: file })
    }

    onContactSubmit(contact) {
        contactSchema
            .validate(contact)
            .then(() => {
                if (contact.supportType == 1) {
                    deliverySchema
                        .validate(contact)
                        .then(() => {
                            // Because of the deliverySchema validation orderNumber1 is required and transfered onto the viewmodel orderNumber and sent to backend.
                            contact.orderNumber = contact.orderNumber1
                            this.props.createTicket(contact, this.state.file)
                        })
                        .catch((error) => this.props.setError(error))
                } else if (contact.supportType == 4) {
                    batchSchema
                        .validate(contact)
                        .then(() => {
                            this.props.createTicket(contact, this.state.file)
                        })
                        .catch((error) => this.props.setError(error))
                } else {
                    this.props.createTicket(contact, this.state.file)
                }
            })
            .catch((error) => this.props.setError(error))
    }

    render() {
        return (
            <ContactForm
                countries={this.props.countries}
                supportTypes={this.props.supportTypes}
                claimCategories={this.props.claimCategories}
                contact={this.state.contact}
                errors={this.props.errors}
                contactFormSent={this.props.contactFormSent}
                onChange={(propName, value) =>
                    this.handleContactInputChange(propName, value)
                }
                onSubmit={(contact) => this.onContactSubmit(contact)}
                onFileChange={(file) => this.onFileChange(file)}
            />
        )
    }
}

const mapStateToProps = (state) => {
    const { contact } = state
    return {
        ...contact,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        loadCountries: () => dispatch(getCountries()),
        loadSupportTypes: () => dispatch(getSupportTypes()),
        loadClaimCategories: () => dispatch(getClaimCategories()),
        createTicket: (contact, file) => dispatch(createTicket(contact, file)),
        setError: (error) => dispatch(setError(error)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ContactContainer)
